import { render, staticRenderFns } from "./genderDistChart.vue?vue&type=template&id=6910d36e"
import script from "./genderDistChart.vue?vue&type=script&lang=js"
export * from "./genderDistChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports